module.exports = __webpack_public_path__ + "static/img/best-picture-3b-mob.cb069bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/best-picture-3b-mob.jpg
// module id = 68
// module chunks = 0